module.exports = __webpack_public_path__ + "static/rena-22e09fca76c2f5c2530d9accf27afbc6.jpg";